import Node from 'ln/node/Node';
import MediumEditor from 'medium-editor';
import { scanner } from 'ln/view/Scanner';

var options = {
	toolbar: {
		buttons: [ 'bold', 'italic', 'orderedlist', 'unorderedlist' ]
	}
};

var anchorOptions = {
	toolbar: {
		buttons: [ 'bold', 'italic', 'orderedlist', 'unorderedlist', 'anchor' ]
	}
};

var editor;
scanner.ioc.add( 'editable', function( node ){
	if( !editor ){
		editor = new MediumEditor( [ node.native ], options );
	} else {
		editor.addElements( [ node.native ] );
	}
	return editor;
});


var anchorEditor;
scanner.ioc.add( 'editable-anchor', function( node){
	if( !anchorEditor ){
		anchorEditor = new MediumEditor( [ node.native ], anchorOptions );
	} else {
		anchorEditor.addElements( [ node.native ] );
	}
	return anchorEditor;
});

/*

var instance;

export function setup( node:Node ) {

	var elements = node.native.querySelectorAll( '[view="editable"]' );

	if( !instance ) { 
		instance = new MediumEditor( elements, options );
	} else {
		instance.addElements( elements );
	}
	return instance;
}

var instance_anchor;

export function setupLink( node:Node ){
	
	var elements = node.native.querySelectorAll( '[view="editable-link"]' );
	
	if( !instance_anchor ) { 
		instance_anchor = new MediumEditor( elements, anchorOptions );
	} else {
		instance_anchor.addElements( elements );
	}
	return instance_anchor;
} */
